import endpoints from '../endpoints.ts';
import { OutboundDocumentStatusEnum } from '../enums';
import { fetch } from './helpers.ts';

export namespace OutboundDocumentStatusAPI {
  export namespace Request {}

  export namespace Response {
    export interface ReadStatusCountByUserId {
      status: OutboundDocumentStatusEnum;
      count: number;
    }
  }
}

const outoundDocumentStatus = {
  read: {
    statusCount: {
      by: {
        userId: (): Promise<
          OutboundDocumentStatusAPI.Response.ReadStatusCountByUserId[] | null
        > => {
          const url =
            endpoints.outboundDocumentStatus.read.statusCount.by.userId();
          return fetch<
            OutboundDocumentStatusAPI.Response.ReadStatusCountByUserId[]
          >(url, 'GET');
        },
      },
    },
  },
};

export default outoundDocumentStatus;
